import { SubscriberStats } from '@opentok/client';
import { getOr, last } from '../utils';
import config from './config';

export default function getLatestSampleWindow(
  stats: SubscriberStats[],
  bandwidthTestInterval: number
): SubscriberStats[] {
  const mostRecentTimestamp: number = getOr(0, 'timestamp', last(stats));
  const bandwidthTimeTest = bandwidthTestInterval
    ? bandwidthTestInterval * 5
    : config.steadyStateSampleWindow;
  const oldestAllowedTime: number = mostRecentTimestamp - bandwidthTimeTest;
  return stats.filter(
    (stat: SubscriberStats) => stat.timestamp >= oldestAllowedTime
  );
}
